import { CACHE_SETTINGS } from "./constants";

export default function fetcher(url, options={}, cacheTime=CACHE_SETTINGS.FETCH_CACHE) {
  return fetch(
    url,
    options,
    {
      next: { revalidate: cacheTime }
    })
}